import React from "react";
import { StyleSheet, View } from "react-native";
import { layout } from "@/constants";
import Text from "./Text";

/**
 * Props for the Title component
 */
interface TitleProps {
  /** The main title text */
  children: React.ReactNode;
  /** Optional subtitle text displayed below the title */
  subtitle?: string;
}

/**
 * A reusable Title component that provides consistent styling for page titles.
 * Uses semiBold variant and title size from the typography system.
 * Optionally includes a subtitle in secondary color.
 */
export default function Title({ children, subtitle }: TitleProps) {
  return (
    <View style={styles.container}>
      <Text variant="semiBold" size="xlarge" style={styles.title}>
        {children}
      </Text>
      {subtitle && (
        <Text size="medium" color="secondary" style={styles.subtitle}>
          {subtitle}
        </Text>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    paddingBottom: layout.space.xl
  },
  title: {
    textAlign: "center"
  },
  subtitle: {
    textAlign: "center",
    marginTop: layout.space.xs
  }
});
